import { useRoute } from '@react-navigation/native'
import { useQuery } from '@tanstack/react-query'

import { getDocumentUploadURL } from './function'

export const useGetDocumentUploadURL = (fieldId: string) => {
  const { params } = useRoute()
  const { hash } = params ?? {}

  return useQuery({
    queryKey: ['useGetDocumentURL', fieldId, hash],
    queryFn: () => getDocumentUploadURL(fieldId, hash),
    enabled: false,
  })
}
